import React from 'react';

import './Error.component.css';

export default class Error extends React.Component {
    render() {
        return (
            <div className="error-container">
                We encountered an unexpected problem.  Please use the table in email reply.
            </div>
        );
    }
}